import SsnLockIcon from "@/assets/icons/ssn-lock.svg";

export const inputIcons = {
  ssn: SsnLockIcon,
};

export type InputIconType = keyof typeof inputIcons;
